import { GlobalViewConstant, WORKFLOWEVENT } from '../constants/global-view-constant';
import { WorkFlow } from '../models/global-view';

const normalizeWorkflowName = (name: string): string => name.toLowerCase().split(' ').join('');

const isWorkflowNameMatch = (left: string, right: string): boolean => {
  const leftNormalized = normalizeWorkflowName(left);
  const rightNormalized = normalizeWorkflowName(right);

  return leftNormalized.includes(rightNormalized) || rightNormalized.includes(leftNormalized);
};

export const checkWorkflowChartType = (type: string, eventType: string): boolean => {
  return isWorkflowNameMatch(type, eventType);
};

export const getWorkFlowDisplayName = (apiName: string): string => {
  for (const item of GlobalViewConstant.workFlowItems) {
    if (item.name === WORKFLOWEVENT.ALL_LABEL) {
      continue;
    }

    if (isWorkflowNameMatch(apiName, item.name) || isWorkflowNameMatch(apiName, item.value)) {
      return item.name;
    }
  }

  return apiName;
};

export const matchesWorkflowChart = (workflowName: string, chartLabel: string): boolean => {
  return getWorkFlowDisplayName(workflowName) === chartLabel || checkWorkflowChartType(chartLabel, workflowName);
};

export const isWorkflowAvailableForChart = (workflows: WorkFlow[], chartLabel: string): boolean => {
  if (!workflows?.length) {
    return false;
  }

  return workflows.some(wf => matchesWorkflowChart(wf.name, chartLabel));
};
